import * as Bixby from '../core';

export abstract class TagsService {
  private static baseUrl = Bixby.Constants.API_TAGSCONTROLLER;
  
  public static async getSuggestionsAsync(
    request: Bixby.Models.TagsRequest
  ): Promise<Bixby.Models.TagSuggestion[]> {
    const url = `${TagsService.baseUrl}/${Bixby.Constants.API_ACTION_TAGS_SUGGEST}${Bixby.Utils.objectToQueryString(request)}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }
}
